package com.parmartechnologies.communication.core.handler


import androidx.compose.runtime.CompositionLocalContext
import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.communication.core.repository.AuthRepository
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.communication.features.device.handler.DeviceHandler
import com.parmartechnologies.core.country.CountryCode
import com.parmartechnologies.storage.constant.KeyConstant
import com.parmartechnologies.storage.store.UserDefaults
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import kotlin.time.ExperimentalTime


class AuthHandler {
    val json = Json {
        encodeDefaults = true
        ignoreUnknownKeys = true
        isLenient = true
    }
    var viewModel: AuthViewModel? = null
    val repository = AuthRepository()
    var context: CompositionLocalContext? = null
    var deviceId = ""
    var otpFromSever = ""
    var dialCode = ""
    var countryCode: CountryCode? = null
    val UserID: String
        get() {
            val user = shared().repository.authLiveData.value
            if (user._id.isEmpty()) {
                val credentials: String = UserDefaults.shared().retrieveCredentials()
                if (credentials.isNotEmpty()) {
                    val userObj: FriendlyUser = json.decodeFromString(credentials)
                    CoroutineScope(Job() + Dispatchers.Main).launch {
                        repository.authLiveData.emit(userObj)
                        repository.isLoggedInState.emit(true)
                    }
                    return user._id
                }
            }
            return user._id
        }
    val userName: String
        get() {
            val user = shared().repository.authLiveData.value
            if (user.Name.isEmpty() == true) {
                val credentials: String = UserDefaults.shared().retrieveCredentials()
                if (credentials.isNotEmpty()) {
                    val userObj: FriendlyUser = json.decodeFromString(credentials)
                    CoroutineScope(Job() + Dispatchers.Main).launch {
                        repository.authLiveData.emit(userObj)
                        repository.isLoggedInState.emit(true)
                    }
                    return user.Name
                }
            }
            return user.Name.toString()
        }
    val mobile: String
        get() {
            val user = shared().repository.authLiveData.value
            if (user.MobileNumber.isEmpty() == true) {
                val credentials: String = UserDefaults.shared().retrieveCredentials()
                if (credentials.isNotEmpty()) {
                    val userObj: FriendlyUser = json.decodeFromString(credentials)
                    return userObj.MobileNumber
                }
            }
            return user.MobileNumber
        }
    val mobileNumber: String
        get() {
            val mobile = shared().repository.mobileNumber.value
            return mobile
        }
    val email: String
        get() {
            val user = shared().repository.authLiveData.value
            if (user.EmailID.isEmpty() == true) {
                val credentials: String = UserDefaults.shared().retrieveCredentials()
                if (credentials.isNotEmpty()) {
                    val userObj: FriendlyUser = json.decodeFromString(credentials)
                    return userObj.EmailID
                }
            }
            return user.EmailID
        }
    val userMobile: String
        get() {
            val user = shared().repository.authLiveData.value
            return user.MobileNumber
        }

    init {
        instance = this
    }

    var onLogout: (() -> Unit)? = null

    fun logout() {
        UserDefaults.shared().remove(KeyConstant.loginDetails)
        if (onLogout != null) {
            onLogout!!()
        }
    }

    companion object {
        private var instance: AuthHandler? = null
        fun shared(): AuthHandler {
            if (instance != null) {
                return instance as AuthHandler
            } else {
                return AuthHandler()
            }
        }
    }

    fun isLoggedIn(): Boolean {
        return repository.isLoggedInState.value
    }

    fun setup(model: AuthViewModel) {
        viewModel = model
    }

    @OptIn(ExperimentalTime::class)
    fun checkIfLoggedIn() {
        val credentials: String = UserDefaults.shared().retrieveCredentials()
        if (credentials.isNotEmpty()) {
            val user: FriendlyUser = json.decodeFromString(credentials)
            CoroutineScope(Job() + Dispatchers.Main).launch {
                repository.authLiveData.emit(user)
                repository.isLoggedInState.emit(true)
            }
            shared().updateExistingTokenToServer(user._id)
        } else {
            CoroutineScope(Job() + Dispatchers.Main).launch {
                repository.authLiveData.emit(FriendlyUser())
                repository.isLoggedInState.emit(false)
            }
        }
    }

    fun updateTokenToServer(
        token: String
    ) {
        checkIfLoggedIn()
        DeviceHandler.shared().setCurrentDeviceToken(token)
    }

    private fun updateExistingTokenToServer(UserID: String) {
        val token = UserDefaults.shared().retrieve(KeyConstant.fcmToken)
        if (UserID.isNotEmpty() && token.isNotEmpty()) {
//            val request = UpdateFCMTokenRequest(UserID, token, uuid())
//            CoroutineScope(Job() + Dispatchers.Default).launch {
//                AuthNetwork().updateToken(request) {
//                    if (it?.status == "Success") {
//                        print("FCM Updated in Server")
//                        UserDefaults.shared().remove(KeyConstant.fcmToken)
//                    } else {
//                        print("Couldn't update FCM Updated in Server")
//                    }
//                }
//            }
        }
    }
}